<template>
  <div>
    <input :value="inputValue" label="URL" solo readonly class="search-input" />
    <!-- <TextButton buttonText="복사" IconBackgroundColor="black" class="ml-2" /> -->
    <TextButton buttonText="복사" iconBackgroundColor="black" class="ml-2" :copyText="inputValue" />
  </div>
</template>

<script>
import TextButton from '@/components/playlist/CopyButton.vue';
import PlaylistApi from "@/api/playlist/PlaylistApi";

export default {
  components: {
    TextButton,
  },
  props: {
    groupId: {
      type: [Number, String],
      required: true,
    }
  },
  name: 'PlayerUrlCopy',
  data() {
    return {
      inputValue: '',
    }
  },
  mounted() {
    this.url(this.groupId);
  },
  methods: {
    async url(groupId) {
      const response = await PlaylistApi.playlistUUid(groupId);
      const playerUrl = window.location.protocol + '//' + window.location.hostname + '/play?' + response.uuid;
      this.inputValue = playerUrl;
      this.$emit('updateUrl', response.uuid);
      //console.log('re', response.uuid);
    }
  },
  watch: {
    groupId(newValue, oldValue) {
      //console.log('실행!');
      if (newValue !== oldValue && !isNaN(parseFloat(newValue))) {
        this.url(newValue);
      }
    }
  }
};
</script>

<style scoped>
.search-input {
    width: 66%;
    height: 36px;
    padding: 8px;
    margin-bottom: 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    background: #fff;
}
input:focus  {
    outline: none;
    border: 1px solid #999;
}
</style>
